<template>
  <v-dialog name="asd" v-model="modalComputed" persistent scrollable max-width="780" v-if="filialComputed !== undefined">
    <v-card>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Upload de Planilha de Aliquotas - Empresa {{filialComputed.cc_fil}}, PDV {{filialComputed.cc_pdv}}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col>
              <p>
                Faça o download da planilha de extensão csv e faça o upload para dentro do sistema utilizando o campo abaixo. Caso não tenha a planilha, acesso o site para maiores informações: <a href="https://deolhonoimposto.ibpt.org.br/" target="_blank">https://deolhonoimposto.ibpt.org.br/</a>
              </p>
              <v-container fluid v-if="isImportado">
                <v-row>
                  <v-col class="d-flex justify-center">
                    <v-icon size="45" color="primary">mdi-check</v-icon><br />Tabela importada com sucesso!
                  </v-col>
                </v-row>
              </v-container>
              <div>
                  <v-file-input ref="certificado" clearable label="Arquivo" v-model="arquivo"></v-file-input>
                  <v-btn depressed outlined color="primary" @click="salvar()" :disabled="arquivo === undefined">FAZER UPLOAD</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'IBPT',

  data() {
    return {

      arquivo: undefined,
      isImportado: false,

      filialTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    filial: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    salvar(){

      const formData = new FormData();
      formData.append("arquivo", this.arquivo);
      formData.append("cc_fil", this.filialComputed.cc_fil)
      
      this.$store.dispatch('fazerUploadTabelaIBPT', formData).then(() => {
        this.arquivo = undefined
        this.isImportado = true
      }).catch()

    }
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialComputed: {
      get: function() { 
        return this.filialTemp
      },
      set: function(value) {
        this.filialTemp = value
      }
    }
  },

  mounted: function() {

  },

  created: function() {

    this.modalComputed = this.modal
    this.filialComputed = this.filial
    this.$emit('a')

  }

}
</script>